/**
 * GalleryPage - Grid gallery with zoom-to-change-density (iPhone Photos style)
 *
 * Access gated: Shows blurred preview without subscription
 */

// NOTE: Old infinite canvas gallery was GalleryCanvas - still available in features/gallery/components/GalleryCanvas.tsx
// To revert, change PhotosGrid back to GalleryCanvas below
import { GalleryProvider, PhotosGrid } from '../features/gallery'
import { useAccessLevel } from '@/hooks/useAccessLevel'
import { useGallerySessionTracker } from '@/hooks/useGallerySessionTracker'
import { BlurredContent } from '@/components/ui/BlurredContent'

/** Wrapper that tracks gallery sessions for VIP progress */
function TrackedGallery() {
  useGallerySessionTracker()
  return (
    <GalleryProvider>
      <PhotosGrid />
    </GalleryProvider>
  )
}

export function GalleryPage() {
  const { hasAccess, loading } = useAccessLevel()

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#4AA3CC]" />
      </div>
    )
  }

  // Show blurred gallery if no subscription
  if (!hasAccess) {
    return (
      <BlurredContent message="Subscription required to view gallery">
        <GalleryProvider>
          <PhotosGrid />
        </GalleryProvider>
      </BlurredContent>
    )
  }

  return <TrackedGallery />
}
